"use client";
import { MotionStack, MotionTypography } from "@cc/motion-components";
import SectionWrapper from "@cc/section-wrapper";
import { StaticImageData } from "next/image";
import ReactiveBreadcrumb from "@/commonComponents/breadcrumb";
import {
  bottomToToptextStagger,
  bottomToToptextStaggerChildren,
} from "@/commonComponents/animations";
import ArrowBannerBackground, {
  ArrowBannerBackgroundProps,
} from "@/commonComponents/arrow-banner-background";
import { isArray } from "lodash";

export interface OurLegacyBannerProps {
  data: {
    banner: ArrowBannerBackgroundProps["images"] | string | StaticImageData;
    title: string;
  };
}

const OurLegacyBanner = (props: OurLegacyBannerProps) => {
  const { data } = props;
  const { banner, title } = data;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) =>
            `${theme.palette.gradient.darkToTransparentRight},${
              banner &&
              !isArray(banner) &&
              (typeof banner === "string" || "src" in banner)
                ? `url(${typeof banner === "string" ? banner : banner.src})`
                : ""
            } no-repeat`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          position: "relative",
        },
      }}
      py={{ xs: 2, md: 4 }} // Todo: basePy
      pb={{ xs: 4, md: 8 }}
      minHeight={{ xs: 334, lg: 400, xl: 500 }}
    >
      <ReactiveBreadcrumb />
      {isArray(banner) && (
        <ArrowBannerBackground
          images={banner as ArrowBannerBackgroundProps["images"]}
        />
      )}
      {title && (
        <MotionStack
          mt={"auto"}
          maxWidth={863}
          rowGap={3}
          variants={bottomToToptextStagger()}
          initial={"initial"}
          animate={"animate"}
        >
          <MotionTypography
            variant="h1"
            variants={bottomToToptextStaggerChildren}
          >
            {title}
          </MotionTypography>
        </MotionStack>
      )}
    </SectionWrapper>
  );
};

export default OurLegacyBanner;
